module.exports = __webpack_public_path__ + "static/media/recenter.16da4e84.svg";